function EolIcon() {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.26777 2.20703C8.27737 2.20703 7.47449 3.00991 7.47449 4.00031C7.47449 4.99072 8.27737 5.7936 9.26777 5.7936C10.2582 5.7936 11.0611 4.99072 11.0611 4.00031C11.0611 3.00991 10.2582 2.20703 9.26777 2.20703ZM5.97449 4.00031C5.97449 2.18148 7.44894 0.707031 9.26777 0.707031C11.0866 0.707031 12.5611 2.18148 12.5611 4.00031C12.5611 5.81915 11.0866 7.2936 9.26777 7.2936C7.44894 7.2936 5.97449 5.81915 5.97449 4.00031Z"
        fill="#135200"
      />
      <path
        d="M16.2872 4.96094H2.24902L3.40719 19.7834H15.129L16.2872 4.96094Z"
        fill="#E4EEE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.69843 4.45168C1.84038 4.2982 2.03996 4.21094 2.24903 4.21094H16.2872C16.4962 4.21094 16.6958 4.2982 16.8378 4.45168C16.9797 4.60516 17.0512 4.81093 17.0349 5.01936L15.8767 19.8418C15.8462 20.2322 15.5206 20.5334 15.129 20.5334H3.40719C3.01563 20.5334 2.68997 20.2322 2.65947 19.8418L1.5013 5.01936C1.48502 4.81093 1.55647 4.60516 1.69843 4.45168ZM3.05991 5.71094L4.10087 19.0334H14.4353L15.4763 5.71094H3.05991Z"
        fill="#135200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.69818 4.45168C1.84014 4.2982 2.03972 4.21094 2.24878 4.21094H16.2869C16.496 4.21094 16.6956 4.2982 16.8375 4.45168C16.9795 4.60516 17.0509 4.81093 17.0346 5.01936L15.8765 19.8418C15.846 20.2322 15.5203 20.5334 15.1288 20.5334H3.40694C3.01539 20.5334 2.68972 20.2322 2.65922 19.8418L1.50106 5.01936C1.48477 4.81093 1.55623 4.60516 1.69818 4.45168ZM3.05967 5.71094L4.10063 19.0334H14.4351L15.476 5.71094H3.05967Z"
        fill="#135200"
      />
      <path
        d="M16.9878 4.50586H1.54785V4.96195H16.9878V4.50586Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.797852 4.50586C0.797852 4.09165 1.13364 3.75586 1.54785 3.75586H16.9878C17.402 3.75586 17.7378 4.09165 17.7378 4.50586V4.96195C17.7378 5.37617 17.402 5.71195 16.9878 5.71195H1.54785C1.13364 5.71195 0.797852 5.37617 0.797852 4.96195V4.50586Z"
        fill="#135200"
      />
    </svg>
  );
}

export default EolIcon;
